export default "__VITE_ASSET__Blpohbm___"